// DOMの読み込みが完了したら実行
document.addEventListener("DOMContentLoaded", () => {
  /**
   * 各 ".hb-collection" セクション内のSwiperを初期化
   */
  document.querySelectorAll(".hb-collection").forEach((collectionSection) => {
    // 各セクション内のすべてのSwiperを初期化
    collectionSection.querySelectorAll(".swiper").forEach((swiperElement) => {
      // Swiperが未初期化の場合のみ初期化
      if (!swiperElement.classList.contains("swiper-initialized")) {
        new Swiper(swiperElement, {
          loop: false, // ループ機能をオフ
          speed: 500, // スライドアニメーションの速度（ミリ秒）
          slidesPerView: "auto", // 初期表示のスライド数
          spaceBetween: 9, // スライド間の余白
          slidesOffsetBefore: 16, // スライドの開始位置オフセット
          slidesOffsetAfter: 16, // スライドの終了位置オフセット
          navigation: {
            nextEl: swiperElement.querySelector(".banner-button-next"), // 次へボタン
            prevEl: swiperElement.querySelector(".banner-button-prev"), // 前へボタン
          },
          pagination: {
            el: swiperElement.querySelector(".banner-pagination"), // ページネーション
            clickable: true, // ページネーションをクリック可能に
          },
          breakpoints: {
            749: {
              slidesPerView: "auto", // ブレークポイント時のスライド数
              spaceBetween: 16, // ブレークポイント時の余白
              slidesOffsetBefore: 0, // 開始位置のオフセットをリセット
              slidesOffsetAfter: 0, // 終了位置のオフセットをリセット
            },
          },
        });
      }
    });

    // タブ切り替え処理
    const collectionTabs = collectionSection.querySelectorAll(
      ".hb-js-brandSelectBtn > li"
    );
    const collectionLists =
      collectionSection.querySelectorAll(".hb-js-activeItem");

    // タブボタンごとにクリックイベントを追加
    collectionTabs.forEach((tab, index) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault(); // デフォルトのリンク動作を防ぐ


        // 全てのタブとリストからアクティブクラスを削除
        collectionTabs.forEach((t) => t.classList.remove("add-active"));
        collectionLists.forEach((list) => list.classList.remove("add-active"));

        // クリックされたタブと対応するリストにアクティブクラスを追加
        tab.classList.add("add-active");
        if (collectionLists[index]) {
          collectionLists[index].classList.add("add-active");
        }
      });
    });
  });
});
